import React from "react"
import useTranslations from "../../../utils/useTranslations"
import ComparisonPanels from "../../../components/comparisonPanels"

import heroImgWebp from "../../../images/products/heroes/premium-web.webp"
import heroImg from "../../../images/products/heroes/premium-web.png"
import heroImgWebp2x from "../../../images/products/heroes/premium-web@2x.webp"
import heroImg2x from "../../../images/products/heroes/premium-web@2x.png"

import Button from "../../../components/button"
import Logo from "../../../components/logo"
import backgrounds from "../../../components/backgrounds"


const heroImgAlt = "Buy BitTorrent Web Pro"

class BittorrentWebPremium extends React.Component {

  render(){

    const { text, pageName } = this.props.pageContext
    const t = useTranslations(text)
    const { unlocalizedPath }  = this.props.pageContext

    return (
      <>
        <div className="top-section-container p-0 pb-md-5 pt-md-3 background-noise-dark" style={backgrounds.darkCorners}>

          <div className="container text-dark py-2">

            <div className="row text-center mt-3 mt-sm-5">
              <div className="col-md-6 mt-md-4 order-md-1 px-md-0 pt-lg-5">
                <Logo color="black" tag="p" productName="Web Premium" className="mb-4"/>
                <img src={heroImg} alt={heroImgAlt} className="img-fluid d-block d-md-none ml-auto position-relative" style={{left: '6%'}}></img>
                <div style={{fontSize: '10px'}} className="position-relative d-block d-md-none mt-2 mb-4"><a id="products-win-btweb-premium-bt-now-mobile" href="https://now.bt.co/" target="_blank" rel="noopenner noreferrer" className="text-dark text-decoration-none">now.bt.co</a> content displayed pursuant to license.</div>
                <div className="text-size-24 text-spacing-1 font-weight-normal"><h1 className="text-size-24 font-weight-normal m-0 d-inline">{t(`Safe torrent downloads.`)}</h1></div>
                <Button  href={`${unlocalizedPath}#comparison-panels`} id="products-win-btweb-premium-hero-cta" className=" btn-primary mt-3 mt-md-4 mb-4 button-filled text-spacing-1 px-5">{t(`BUY NOW`)}</Button>
              </div>
              <div className="col-md-6 mb-5 order-md-2 d-flex justify-content-center flex-column">
                {/*<img src={heroImg} alt={heroImgAlt} className="img-fluid d-none d-md-block"></img>*/}

                <picture>
                  <source srcSet={`${heroImgWebp} 1x, ${heroImgWebp2x} 2x`} type="image/webp"></source>
                  <img srcSet={`${heroImg} 1x, ${heroImg2x} 2x`} src={heroImg} alt={heroImgAlt} className="img-fluid d-none d-md-block"></img>
                </picture>
                <div style={{fontSize: '10px', left: '-5%'}} className="position-relative d-none d-md-block mt-2"><a id="products-win-btweb-premium-bt-now" href="https://now.bt.co/" target="_blank" rel="noopenner noreferrer" className="text-dark text-decoration-none">now.bt.co</a> content displayed pursuant to license.</div>

              </div>
            </div>
          </div>
        </div>

        <div className="container my-5 py-md-5">
        	<p className="premium-title">{t(`<b>BitTorrent</b> Web Pro`)}</p>
        	<p className="premium-description">
        		{t(`Try our most popular premium web torrent client and keep your PC safe. A safe torrent scanner automatically checks torrents for threats before you download, as well as displays helpful info while you search to find the right torrent: file size, resolution, and number of seeds and leeches. Pro includes access to premium customer support.`)}
        	</p>

        	<p className="premium-title mt-5 ">{t(`<b>BitTorrent</b> Web Pro+VPN`)}</p>
        	<p className="premium-description">
        		{t(`Get all Pro features, as well as a 1-year subscription to CyberGhost VPN. Includes built-in threat protection to keep your torrent downloads clean and a utility displays helpful info when you search for torrents: file size, resolution, and number of seeds and leeches. Get VPN on up to 5 devices to protect your online identity and safeguard your personal data from hackers.`)}
        	</p>
        </div>

        <div className="container-fluid position-relative overflow-hidden background-noise-dark" style={backgrounds.darkCorners}>
          <div className="container my-5 z-2">
            <p className="text-center font-weight-bold feature-list-title-2 mb-3 text-dark">{t(`Compare`)}</p>
            <h2 className="text-center mb-5 text-size-24 font-weight-normal text-dark">
                {t(`Compare BitTorrent Web Premium Versions`)}
            </h2>

            <ComparisonPanels pageContext={{ "text": text, "pageName":pageName, "isMac":true}} noShadow={true}/>
          </div>
        </div>


        <div className="container mb-5 mt-5">
          <h2 className="feature-list-title-1 font-weight-normal">
              {t(`BitTorrent Tips for Safely Downloading Torrents`)}
          </h2>
        </div>

        <div className="container my-md-5 py-md-5">

        	<div className="row mb-5 mb-md-5 pb-md-5">
        		<div className="ml-md-5 col-md-3 text-md-right premium-tip-title mb-3 mb-md-0 text-size-24">
        			{t(`Avoid or bypass <br><b>unsafe websites</b>`)}

        		</div>
        		<div className="ml-md-3 col-md-7 product-faq-answer">
        			{t(`<b>Just like browsing the internet in general,</b> many sites are known to distribute malware and viruses. Therefore, it’s not surprising that some sites that host torrent files are not safe. There are a few ways to avoid malicious sites and safely download torrents. First, it’s helpful if you can avoid these sites entirely. Luckily, our Pro version includes a safe torrent scanner that helps you do just that. The utility turns BitTorrent Web Pro into a safer torrent program by not only bypassing potentially malicious sites, but by scanning torrent files before you download when using the BitTorrent Web online torrent client.`)}

        		</div>
        	</div>
        	<div className="row mb-5 mb-md-5 pb-md-5">
        		<div className="ml-md-5 col-md-3 text-md-right premium-tip-title mb-3 mb-md-0 text-size-24">
        			{t(`How to avoid viruses<br>in your torrent <br><b>download</b>`)}

        		</div>
        		<div className="ml-md-3 col-md-7 product-faq-answer">
        			{t(`<b>The best way to avoid viruses</b> in your torrent downloads is to bypass visiting malicious websites. If you have BitTorrent Web Pro, it includes a premium utility that jumps into action when you search for a torrent on a search engine like Google or Yahoo. The utility displays real torrent links grabbed from those results, and you can download torrents from within the utility instead of visiting potentially harmful websites. As a second layer of protection, the utility checks each file for threats, ensuring they are safe when using BitTorrent Web as an online torrent downloader.`)}
        		</div>
        	</div>



        </div>

      </>
    )

  }
}

export default BittorrentWebPremium
